// IABA-ICTS-Metadata-Portal\frontend\src\utils\filePropTypes.js
import PropTypes from "prop-types";

const commonDetectorShape = PropTypes.shape({
  name: PropTypes.string,
  type: PropTypes.string,
  radiation_type: PropTypes.string,
  config_file: PropTypes.string,
});

export const filePropTypesByModelKey = {
  cmam_toferda_files: PropTypes.shape({
    name: PropTypes.string,
    sample_ID: PropTypes.string,
    beam_isotope: PropTypes.shape({
      symbol: PropTypes.string,
      mass_number: PropTypes.number,
    }),
    beam_charge_state: PropTypes.number,
    beam_energy: PropTypes.number,
    beam_energy_units: PropTypes.string,
    beam_current: PropTypes.number,
    beam_current_units: PropTypes.string,
    incident_angle: PropTypes.number,
    incident_angle_units: PropTypes.string,
    exit_angle: PropTypes.number,
    exit_angle_units: PropTypes.string,
    TOF_detector: commonDetectorShape,
    sample_TOF_detector_distance: PropTypes.number,
    sample_TOF_detector_distance_units: PropTypes.string,
    length_of_flight: PropTypes.number,
    length_of_flight_units: PropTypes.string,
    TOF_station_BIAS_voltage: PropTypes.number,
    TOF_station_BIAS_voltage_units: PropTypes.string,
    TOF_TAC_range: PropTypes.number,
    TOF_TAC_range_units: PropTypes.string,
    TOF_TAC_multiplier: PropTypes.number,
    TOF_ADC_gain: PropTypes.number,
    TOF_ADC_range: PropTypes.number,
    energy_detector: commonDetectorShape,
    sample_energy_detector_distance: PropTypes.number,
    sample_energy_detector_distance_units: PropTypes.string,
    energy_detector_BIAS_voltage: PropTypes.number,
    energy_detector_BIAS_voltage_units: PropTypes.string,
    energy_shaping_time: PropTypes.number,
    energy_shaping_time_units: PropTypes.string,
    energy_amplifier_coarse_gain: PropTypes.number,
    energy_amplifier_fine_gain: PropTypes.number,
    energy_ADC_gain: PropTypes.number,
    energy_ADC_range: PropTypes.number,
    coincidence_window: PropTypes.number,
    coincidence_window_units: PropTypes.string,
    notes: PropTypes.string,
  }),

  cna_std_erda_files: PropTypes.shape({
    name: PropTypes.string,
    sample_ID: PropTypes.string,
    detector: commonDetectorShape,
    beam_isotope: PropTypes.shape({
      symbol: PropTypes.string,
      mass_number: PropTypes.number,
    }),
    beam_charge_state: PropTypes.number,
    beam_energy: PropTypes.number,
    beam_energy_units: PropTypes.string,
    beam_current: PropTypes.number,
    beam_current_units: PropTypes.string,
    injection_energy: PropTypes.number,
    injection_energy_units: PropTypes.string,
    terminal_voltage: PropTypes.number,
    terminal_voltage_units: PropTypes.string,
    magnetic_field: PropTypes.number,
    magnetic_field_units: PropTypes.string,
    beam_shape: PropTypes.string,
    beam_shape_width: PropTypes.number,
    beam_shape_width_units: PropTypes.string,
    beam_shape_height: PropTypes.number,
    beam_shape_height_units: PropTypes.string,
    beam_shape_diameter: PropTypes.number,
    beam_shape_diameter_units: PropTypes.string,
    incident_angle: PropTypes.number,
    incident_angle_units: PropTypes.string,
    exit_angle: PropTypes.number,
    exit_angle_units: PropTypes.string,
    scattering_angle: PropTypes.number,
    scattering_angle_units: PropTypes.string,
    is_filter_present: PropTypes.bool,
    filter_material: PropTypes.string,
    filter_thickness: PropTypes.number,
    filter_thickness_units: PropTypes.string,
    sample_detector_distance: PropTypes.number,
    sample_detector_distance_units: PropTypes.string,
    detector_BIAS_voltage: PropTypes.number,
    detector_BIAS_voltage_units: PropTypes.string,
    detector_inverse_current: PropTypes.number,
    detector_inverse_current_units: PropTypes.string,
    shaping_time: PropTypes.number,
    shaping_time_units: PropTypes.string,
    peaking_time: PropTypes.number,
    peaking_time_units: PropTypes.string,
    amplifier_coarse_gain: PropTypes.number,
    amplifier_fine_gain: PropTypes.number,
    adc_gain: PropTypes.number,
    adc_range: PropTypes.number,
    accumulated_charge: PropTypes.number,
    accumulated_charge_units: PropTypes.string,
    notes: PropTypes.string,
  }),

  cna_std_nra_files: PropTypes.shape({
    name: PropTypes.string,
    sample_ID: PropTypes.string,
    reaction: PropTypes.shape({
      reaction_notation: PropTypes.string,
    }),
    detector: commonDetectorShape,
    beam_isotope: PropTypes.shape({
      symbol: PropTypes.string,
      mass_number: PropTypes.number,
    }),
    beam_charge_state: PropTypes.number,
    beam_energy: PropTypes.number,
    beam_energy_units: PropTypes.string,
    beam_current: PropTypes.number,
    beam_current_units: PropTypes.string,
    injection_energy: PropTypes.number,
    injection_energy_units: PropTypes.string,
    terminal_voltage: PropTypes.number,
    terminal_voltage_units: PropTypes.string,
    magnetic_field: PropTypes.number,
    magnetic_field_units: PropTypes.string,
    beam_shape: PropTypes.string,
    beam_shape_width: PropTypes.number,
    beam_shape_width_units: PropTypes.string,
    beam_shape_height: PropTypes.number,
    beam_shape_height_units: PropTypes.string,
    beam_shape_diameter: PropTypes.number,
    beam_shape_diameter_units: PropTypes.string,
    incident_angle: PropTypes.number,
    incident_angle_units: PropTypes.string,
    exit_angle: PropTypes.number,
    exit_angle_units: PropTypes.string,
    scattering_angle: PropTypes.number,
    scattering_angle_units: PropTypes.string,
    is_filter_present: PropTypes.bool,
    filter_material: PropTypes.string,
    filter_thickness: PropTypes.number,
    filter_thickness_units: PropTypes.string,
    sample_detector_distance: PropTypes.number,
    sample_detector_distance_units: PropTypes.string,
    detector_BIAS_voltage: PropTypes.number,
    detector_BIAS_voltage_units: PropTypes.string,
    detector_inverse_current: PropTypes.number,
    detector_inverse_current_units: PropTypes.string,
    shaping_time: PropTypes.number,
    shaping_time_units: PropTypes.string,
    peaking_time: PropTypes.number,
    peaking_time_units: PropTypes.string,
    amplifier_coarse_gain: PropTypes.number,
    amplifier_fine_gain: PropTypes.number,
    adc_gain: PropTypes.number,
    adc_range: PropTypes.number,
    accumulated_charge: PropTypes.number,
    accumulated_charge_units: PropTypes.string,
    notes: PropTypes.string,
  }),

  cna_std_pige_files: PropTypes.shape({
    name: PropTypes.string,
    sample_ID: PropTypes.string,
    detector: commonDetectorShape,
    beam_isotope: PropTypes.shape({
      symbol: PropTypes.string,
      mass_number: PropTypes.number,
    }),
    beam_charge_state: PropTypes.number,
    beam_energy: PropTypes.number,
    beam_energy_units: PropTypes.string,
    beam_current: PropTypes.number,
    beam_current_units: PropTypes.string,
    injection_energy: PropTypes.number,
    injection_energy_units: PropTypes.string,
    terminal_voltage: PropTypes.number,
    terminal_voltage_units: PropTypes.string,
    magnetic_field: PropTypes.number,
    magnetic_field_units: PropTypes.string,
    beam_shape: PropTypes.string,
    beam_shape_width: PropTypes.number,
    beam_shape_width_units: PropTypes.string,
    beam_shape_height: PropTypes.number,
    beam_shape_height_units: PropTypes.string,
    beam_shape_diameter: PropTypes.number,
    beam_shape_diameter_units: PropTypes.string,
    incident_angle: PropTypes.number,
    incident_angle_units: PropTypes.string,
    exit_angle: PropTypes.number,
    exit_angle_units: PropTypes.string,
    scattering_angle: PropTypes.number,
    scattering_angle_units: PropTypes.string,
    is_filter_present: PropTypes.bool,
    filter_material: PropTypes.string,
    filter_diameter: PropTypes.number,
    filter_diameter_units: PropTypes.string,
    filter_thickness: PropTypes.number,
    filter_thickness_units: PropTypes.string,
    sample_detector_distance: PropTypes.number,
    sample_detector_distance_units: PropTypes.string,
    detector_BIAS_voltage: PropTypes.number,
    detector_BIAS_voltage_units: PropTypes.string,
    shaping_time: PropTypes.number,
    shaping_time_units: PropTypes.string,
    peaking_time: PropTypes.number,
    peaking_time_units: PropTypes.string,
    amplifier_coarse_gain: PropTypes.number,
    amplifier_fine_gain: PropTypes.number,
    adc_gain: PropTypes.number,
    adc_range: PropTypes.number,
    accumulated_charge: PropTypes.number,
    accumulated_charge_units: PropTypes.string,
    notes: PropTypes.string,
  }),

  cna_std_pixe_files: PropTypes.shape({
    name: PropTypes.string,
    sample_ID: PropTypes.string,
    detector: commonDetectorShape,
    beam_isotope: PropTypes.shape({
      symbol: PropTypes.string,
      mass_number: PropTypes.number,
    }),
    beam_charge_state: PropTypes.number,
    beam_energy: PropTypes.number,
    beam_energy_units: PropTypes.string,
    beam_current: PropTypes.number,
    beam_current_units: PropTypes.string,
    injection_energy: PropTypes.number,
    injection_energy_units: PropTypes.string,
    terminal_voltage: PropTypes.number,
    terminal_voltage_units: PropTypes.string,
    magnetic_field: PropTypes.number,
    magnetic_field_units: PropTypes.string,
    beam_shape: PropTypes.string,
    beam_shape_width: PropTypes.number,
    beam_shape_width_units: PropTypes.string,
    beam_shape_height: PropTypes.number,
    beam_shape_height_units: PropTypes.string,
    beam_shape_diameter: PropTypes.number,
    beam_shape_diameter_units: PropTypes.string,
    incident_angle: PropTypes.number,
    incident_angle_units: PropTypes.string,
    exit_angle: PropTypes.number,
    exit_angle_units: PropTypes.string,
    scattering_angle: PropTypes.number,
    scattering_angle_units: PropTypes.string,
    is_filter_present: PropTypes.bool,
    filter_material: PropTypes.string,
    filter_diameter: PropTypes.number,
    filter_diameter_units: PropTypes.string,
    filter_thickness: PropTypes.number,
    filter_thickness_units: PropTypes.string,
    sample_detector_distance: PropTypes.number,
    sample_detector_distance_units: PropTypes.string,
    detector_BIAS_voltage: PropTypes.number,
    detector_BIAS_voltage_units: PropTypes.string,
    shaping_time: PropTypes.number,
    shaping_time_units: PropTypes.string,
    peaking_time: PropTypes.number,
    peaking_time_units: PropTypes.string,
    amplifier_coarse_gain: PropTypes.number,
    amplifier_fine_gain: PropTypes.number,
    adc_gain: PropTypes.number,
    adc_range: PropTypes.number,
    accumulated_charge: PropTypes.number,
    accumulated_charge_units: PropTypes.string,
    notes: PropTypes.string,
  }),

  cna_std_rbs_files: PropTypes.shape({
    name: PropTypes.string,
    sample_ID: PropTypes.string,
    detector: commonDetectorShape,
    beam_isotope: PropTypes.shape({
      symbol: PropTypes.string,
      mass_number: PropTypes.number,
    }),
    beam_charge_state: PropTypes.number,
    beam_energy: PropTypes.number,
    beam_energy_units: PropTypes.string,
    beam_current: PropTypes.number,
    beam_current_units: PropTypes.string,
    injection_energy: PropTypes.number,
    injection_energy_units: PropTypes.string,
    terminal_voltage: PropTypes.number,
    terminal_voltage_units: PropTypes.string,
    magnetic_field: PropTypes.number,
    magnetic_field_units: PropTypes.string,
    beam_shape: PropTypes.string,
    beam_shape_width: PropTypes.number,
    beam_shape_width_units: PropTypes.string,
    beam_shape_height: PropTypes.number,
    beam_shape_height_units: PropTypes.string,
    beam_shape_diameter: PropTypes.number,
    beam_shape_diameter_units: PropTypes.string,
    incident_angle: PropTypes.number,
    incident_angle_units: PropTypes.string,
    exit_angle: PropTypes.number,
    exit_angle_units: PropTypes.string,
    scattering_angle: PropTypes.number,
    scattering_angle_units: PropTypes.string,
    is_filter_present: PropTypes.bool,
    filter_material: PropTypes.string,
    filter_thickness: PropTypes.number,
    filter_thickness_units: PropTypes.string,
    sample_detector_distance: PropTypes.number,
    sample_detector_distance_units: PropTypes.string,
    detector_BIAS_voltage: PropTypes.number,
    detector_BIAS_voltage_units: PropTypes.string,
    detector_inverse_current: PropTypes.number,
    detector_inverse_current_units: PropTypes.string,
    shaping_time: PropTypes.number,
    shaping_time_units: PropTypes.string,
    peaking_time: PropTypes.number,
    peaking_time_units: PropTypes.string,
    amplifier_coarse_gain: PropTypes.number,
    amplifier_fine_gain: PropTypes.number,
    adc_gain: PropTypes.number,
    adc_range: PropTypes.number,
    accumulated_charge: PropTypes.number,
    accumulated_charge_units: PropTypes.string,
    notes: PropTypes.string,
  }),
  // Otros modelos aquí...

  cna_ub_pixe_files: PropTypes.shape({
    name: PropTypes.string,
    sample_ID: PropTypes.string,
    beam_isotope: PropTypes.shape({
      symbol: PropTypes.string,
      mass_number: PropTypes.number,
    }),
    beam_charge_state: PropTypes.number,
    beam_energy: PropTypes.number,
    beam_energy_units: PropTypes.string,
    injection_energy: PropTypes.number,
    injection_energy_units: PropTypes.string,
    terminal_voltage: PropTypes.number,
    terminal_voltage_units: PropTypes.string,
    magnetic_field: PropTypes.number,
    magnetic_field_units: PropTypes.string,
    scan_size: PropTypes.string,
    scan_size_units: PropTypes.string,
    time_per_pixel: PropTypes.number,
    time_per_pixel_units: PropTypes.string,
    notes: PropTypes.string,
  }),
};
